export class UndoRedoElement {
    constructor(undoFunc, redoFunc) {
        this.undoFunc = undoFunc;
        this.redoFunc = redoFunc;
    }
}

export class UndoStack {
    constructor() {
        this.undoRedoElements = [];
        this.curIdxToAddInBuffer = 0;
        this.canInteract = true;

        let self = this;
        // could add this in the calendar-container instead...
        document.addEventListener('keydown', (e) => {
            
            if (!self.canInteract) {
                return;
            }

            if (self.curIdxToAddInBuffer < 0 || self.undoRedoElements.length === 0) {
                return;
            }

            const key = e.key;

            if ((e.shiftKey && key === 'z')
              || key === 'y') {

                if (self.curIdxToAddInBuffer >= self.undoRedoElements.length) {
                    // can't redo at end of buffer
                    return;
                }

                const undoRedoElement = self.undoRedoElements[self.curIdxToAddInBuffer];

                undoRedoElement.redoFunc();

                self.curIdxToAddInBuffer++;

            }
            else if (key === 'z') {
                // undo!
                if (self.curIdxToAddInBuffer <= 0) {
                    // can't undo at start of buffer
                    return;
                }

                // 
                const undoRedoElement = self.undoRedoElements[self.curIdxToAddInBuffer - 1];

                undoRedoElement.undoFunc();

                self.curIdxToAddInBuffer--;
            }
        });
    }

    addUndoRedoElement(undoRedoElement) {
        // if it is set, and not the last element...remove all after it
        if (this.curIdxToAddInBuffer >= 0 && this.curIdxToAddInBuffer < (this.undoRedoElements.length - 1)) {
            this.undoRedoElements.length = this.curIdxToAddInBuffer;
        }

        this.undoRedoElements.push(undoRedoElement);
        this.curIdxToAddInBuffer = this.undoRedoElements.length;
    } 
}